import React, {useMemo} from 'react';
import LookupProductCard from '../lookup-product-card';
import VariantOptionPickers from '../variant-option-pickers';

/**
 * Lookup product card with hierarchical variance option pickers.
 */
const AggregatedLookupProductCard = ({
                                         info,
                                         varianceProperties = [],
                                         onAggregatedSelectionChange,
                                         hideMoreLikeThis = true,
                                         ...cardProps
                                     }) => {
    const cardInfo = useMemo(() => {
        if (!info) {
            return info;
        }
        // Suppress "More Like This" on aggregated cards unless caller opts in.
        if (hideMoreLikeThis && info.isAggregated) {
            return {...info, variety: undefined};
        }
        return info;
    }, [hideMoreLikeThis, info]);

    return (
        <LookupProductCard
            {...cardProps}
            info={cardInfo}
            cardExtras={
                info?.isAggregated
                    ? (
                        <VariantOptionPickers
                            info={info}
                            varianceProperties={varianceProperties}
                            onAggregatedSelectionChange={onAggregatedSelectionChange}
                        />
                    )
                    : null
            }
        />
    );
};

export default AggregatedLookupProductCard;
